import { isArray as D } from "./code-utils.js";
export default class ge {
  constructor() {}
  ef() {}
  ff() {}
  Ha(t) {}
  static nf(t, e) {
    if (t && e)
      if (((t = t.toLowerCase()), D(e.cf))) {
        for (let r = 0; r < e.cf.length; r++)
          if (-1 !== t.indexOf(e.cf[r].toLowerCase())) return e.identity;
      } else if (-1 !== t.indexOf(e.cf.toLowerCase())) return e.identity;
  }
}
